import React, {useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {Link} from 'react-router-dom'

import VideoIcon from '../images/videos/video-icon.png'
import HomeSelectedIcon from '../images/old-home/home-selected.png'
import HomeUnselectedIcon from '../images/old-home/home-unselected.png'
import CategorySelectedIcon from '../images/category/category-selected.png'
import CategoryUnselectedIcon from '../images/category/category-unselected.png'
import CartSelectedIcon from '../images/cart/cart-active.png'
import CartUnselectedIcon from '../images/cart/cart.png'
import MySelectedIcon from '../images/my/my-selected.png'
import MyUnselectedIcon from '../images/my/my-unselected.png'
import * as strings from '@/utils/strings'

import './nav.scss'


const Nav = (props) => {
    const {app: appStore} = props;
    const {currentTab, setTab} = appStore

    useEffect(() => {
        const tab = strings.parsePathVar(window.location.href)
        setTab('/' + tab)
    }, []);


    const switchToPage = (path) => {
        setTab(path)
    }

    const renderItem = (
        title,
        path,
        icon,
        iconSelected
    ) => {
        return (
            <Link to={path} className='bottom-nav-item'>
                <img
                    className='bottom-nav-item__icon'
                    alt={title}
                    src={currentTab === path ? iconSelected : icon}
                />
                <span
                    className={`bottom-nav-item__title ${
                        currentTab === path ? 'bottom-nav-item__title--active' : ''
                    }`}
                >
          {title}
        </span>
            </Link>
        )
    }

    const renderLiveEntry = () => {
        return (
            <div className='bottom-nav-live'>
                <Link to='/live'>
                    <img
                        src={VideoIcon}
                        className='bottom-nav-live__icon'
                        alt='直播专区'
                    />
                </Link>
            </div>
        )
    }


    return (
        <div className='bottom-nav'>
            {renderItem('主页', '/home', HomeUnselectedIcon, HomeSelectedIcon)}
            {renderItem(
                '分类',
                '/category',
                CategoryUnselectedIcon,
                CategorySelectedIcon
            )}
            {renderLiveEntry()}
            {renderItem(
                '购物车',
                '/cart',
                CartUnselectedIcon,
                CartSelectedIcon
            )}
            {renderItem('我的', '/my', MyUnselectedIcon, MySelectedIcon)}
        </div>
    )
}

export default inject('app')(observer(Nav))
